export default __webpack_public_path__ + "55a012bdf788451424a472d49a2b08f2.png";